import React, { useState, useEffect } from "react";
import { cdnInstance } from "../axiosInterceptor";
import { ImageLink } from "../utils/constants";
import { toast } from "react-toastify";
import "./styles/Upload.css";
const Upload = ({ initialImage = "", onChange, apiUrl }) => {
 const [filePath, setFilePath] = useState(initialImage || "");
 const [isVideo, setIsVideo] = useState(false);
 const [loading, setLoading] = useState(false);

 useEffect(() => {
  if (initialImage) {
   setFilePath(initialImage);
   setIsVideo(checkIfVideo(initialImage));
  }
 }, [initialImage]);

 const checkIfVideo = (path) => /\.(mp4|webm|ogg)$/i.test(path);

 const handleChange = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
  const isVideoFile = checkIfVideo(file.name);
  const MAX_VIDEO_SIZE_MB = 7;
  const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;

  if (isVideoFile && file.size > MAX_VIDEO_SIZE_BYTES) {
   toast.error(
    `Video size must be less than or equal to ${MAX_VIDEO_SIZE_MB} MB`
   );
   event.target.value = "";
   return;
  }

  setLoading(true);
  const formData = new FormData();
  formData.append("image", file);

  try {
   const response = await cdnInstance.post(`/${apiUrl}`, formData);
   if (response.status === 200) {
    const { path, message } = response.data;
    setFilePath(path);
    setIsVideo(checkIfVideo(path));
    toast.success(message);
    if (onChange) onChange(path);
   }
  } catch (error) {
   toast.error(error.response?.data?.message || "Upload failed");
  } finally {
   setLoading(false);
  }
 };

 const copyToClipboard = () => {
  const fullUrl = ImageLink(filePath);
  navigator.clipboard
   .writeText(fullUrl)
   .then(() => toast.success("Copied to clipboard!"))
   .catch(() => toast.error("Failed to copy URL"));
 };

 const deleteFile = async () => {
  try {
   const response = await cdnInstance.delete("/delete", {
    data: { image: filePath },
   });
   if (response.status === 200) {
    toast.success(response.data?.message || "File deleted");
    setFilePath("");
    setIsVideo(false);
    if (onChange) onChange("");
   }
  } catch (error) {
   toast.error(error.response?.data?.message || "Delete failed");
  }
 };

 return (
  <div className="upload-component">
   {!filePath && (
    <div className="upload-input-wrapper">
     <input
      type="file"
      name="file"
      accept="image/*,video/*"
      onChange={handleChange}
      className="form-control form-control-sm border-dark"
      disabled={loading}
     />
     {loading && <div className="upload-loading">Uploading...</div>}
    </div>
   )}

   {filePath && (
    <div className="upload-preview-wrapper">
     <div className="upload-preview " >
      {isVideo ? (
       <video
        src={ImageLink(filePath)}
        className="preview-media"
        autoPlay
        loop
       />
      ) : (
       <img
        src={ImageLink(filePath)}
        alt="Uploaded"
        className="preview-media "
       />
      )}

      <div className="upload-actions">
       <button
        type="button"
        className="btn btn-sm btn-light me-1"
        onClick={copyToClipboard}
        title="Copy URL"
       >
        <i className="fas fa-copy"></i>
       </button>
       <button
        type="button"
        className="btn btn-sm btn-light"
        onClick={deleteFile}
        title="Delete"
       >
        <i className="fas fa-trash"></i>
       </button>
      </div>
     </div>
    </div>
   )}
  </div>
 );
};

export default Upload;
